import { render, staticRenderFns } from "./MailTemplateEdit.vue?vue&type=template&id=2009ce11"
import script from "./MailTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./MailTemplateEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2009ce11')) {
      api.createRecord('2009ce11', component.options)
    } else {
      api.reload('2009ce11', component.options)
    }
    module.hot.accept("./MailTemplateEdit.vue?vue&type=template&id=2009ce11", function () {
      api.rerender('2009ce11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/MailTemplateEdit.vue"
export default component.exports